import { render, staticRenderFns } from "./newPoints.vue?vue&type=template&id=5091b8dc&scoped=true&"
import script from "./newPoints.vue?vue&type=script&lang=js&"
export * from "./newPoints.vue?vue&type=script&lang=js&"
import style0 from "./newPoints.vue?vue&type=style&index=0&id=5091b8dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5091b8dc",
  null
  
)

export default component.exports